import * as Types from '../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFlatFilterFieldsVariables = Types.Exact<{
  input: Types.FlatFilterFieldsInput;
}>;

export type GetFlatFilterFields = {
  flatFilterFields: {
    flatFields: Array<
      Pick<Types.FilterField, 'target' | 'type' | 'description' | 'isPantherManaged' | 'logType'>
    >;
  };
};

export const GetFlatFilterFieldsDocument = gql`
  query GetFlatFilterFields($input: FlatFilterFieldsInput!) {
    flatFilterFields(input: $input) {
      flatFields {
        target
        type
        description
        isPantherManaged
        logType
      }
    }
  }
`;

/**
 * __useGetFlatFilterFields__
 *
 * To run a query within a React component, call `useGetFlatFilterFields` and pass it any options that fit your needs.
 * When your component renders, `useGetFlatFilterFields` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlatFilterFields({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFlatFilterFields(
  baseOptions: Apollo.QueryHookOptions<GetFlatFilterFields, GetFlatFilterFieldsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFlatFilterFields, GetFlatFilterFieldsVariables>(
    GetFlatFilterFieldsDocument,
    options,
  );
}
export function useGetFlatFilterFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFlatFilterFields, GetFlatFilterFieldsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFlatFilterFields, GetFlatFilterFieldsVariables>(
    GetFlatFilterFieldsDocument,
    options,
  );
}
export function useGetFlatFilterFieldsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetFlatFilterFields, GetFlatFilterFieldsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetFlatFilterFields, GetFlatFilterFieldsVariables>(
    GetFlatFilterFieldsDocument,
    options,
  );
}
export type GetFlatFilterFieldsHookResult = ReturnType<typeof useGetFlatFilterFields>;
export type GetFlatFilterFieldsLazyQueryHookResult = ReturnType<
  typeof useGetFlatFilterFieldsLazyQuery
>;
export type GetFlatFilterFieldsSuspenseQueryHookResult = ReturnType<
  typeof useGetFlatFilterFieldsSuspenseQuery
>;
export type GetFlatFilterFieldsQueryResult = Apollo.QueryResult<
  GetFlatFilterFields,
  GetFlatFilterFieldsVariables
>;
export function mockGetFlatFilterFields({
  data,
  variables,
  errors,
}: {
  data: GetFlatFilterFields;
  variables?: GetFlatFilterFieldsVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: GetFlatFilterFieldsDocument, variables },
    result: { data, errors },
  };
}
